<template>
  <router-view />
</template>

<script setup lang="ts">
// App.vue 作为根组件，只负责路由视图
</script>
